<script>
import { POINT_MARKER_ICON_CONFIG, MARKER_ICONS } from '@vue/components/google-maps/constants/mapSettings';
import GoogleMapsMixin from '@vue/mixins/google-maps';
export default {
  mixins: [GoogleMapsMixin],
  props: {
    appName: {
      required: true
    },
    properties: {
      type: Array,
      required: true
    },
    disabledProperties: {
      type: Array
    },
    zIndex: {
      type: Number
    },
    zoomLevel: {
      type: Number
    },
    highlightedProperty: {},
    searchType: {},
    shouldFitBounds: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      lastHighlightedId: null,
      maxMarkersCount: 250,
      mapMarkers: [],
      initialized: false,
      iconWithLabelSize: {},
      iconSize: {}
    };
  },

  mounted() {
    const { Size, Point } = this.google.maps;

    const sizes = {
      label: {
        width: 38,
        height: 31
      },
      normal: {
        width: 14,
        height: 14
      }
    };

    this.iconWithLabelSize = {
      size: new Size(sizes.label.width, sizes.label.height),
      scaledSize: new Size(sizes.label.width, sizes.label.height), // necessary for IE11
      className: 'property-search-marker',
      labelOrigin: new Point(19, 22)
    };

    this.iconSize = {
      size: new Size(sizes.normal.width, sizes.normal.height),
      scaledSize: new Size(sizes.normal.width, sizes.normal.height) // necessary for IE11
    };

    this.buildMapMarkers();
    this.updateInvalidCoordsCount();
  },

  computed: {
    
    isZoomedIn() {
      return this.zoomLevel && this.zoomLevel >= 10;
    }
    
  },

  methods: {
    handleMouseEvent: _.debounce(function({ eventType, marker, property }) {
      if (eventType == 'mouseover') {
        // marker.setIcon(POINT_MARKER_ICON_CONFIG.active);
        marker.setIcon(this.getMarkerIcon(marker.disabled ? 'disabled' : this.searchType, this.isZoomedIn, true));
        marker.setZIndex(9999);
        this.$emit('marker-mouse-over', property);
      } else if (eventType == 'mouseout') {
        // marker.setIcon(POINT_MARKER_ICON_CONFIG.wolfnet);
        marker.setIcon(this.getMarkerIcon(marker.disabled ? 'disabled' : this.searchType, this.isZoomedIn));
        marker.setZIndex(marker.oldZIndex);
        this.$emit('marker-mouse-out', property);
      } else if (eventType == 'click') {
        if(window.outerWidth >= 992){
          this.$emit('marker-click', property);
        } else {
          this.$emit('marker-touchend', property);
        }
      } else if (eventType == 'touchend') {
        this.$emit('marker-touchend', property);
      }
    }, 200),

    /*
     *  This method generates an icon for the marker.
     *  prefix: this is used to pick which color icon to use
     *  label: should we use the version of the icon that includes a white box for a label below the marker's dot?
     *  active: should we use the hover'd \ tapped state for the icon?
     */
    getMarkerIcon(prefix, label = false, active = false) {
      let size = label ? this.iconWithLabelSize : this.iconSize;

      // // @ToDo Remove This
      // // TESTING ONLY
      // prefix = Math.random() >= 0.5 ? 'wolfnet' : 'rw';
      
      let thePrefix = prefix ? prefix : 'rw';

      let iconName = `${prefix}${label ? 'WithLabel' : ''}${active ? 'Active' : ''}`;

      return {
        url: MARKER_ICONS[iconName],
        ...size
      };
    },

    getMarkerLabel(property) {

      if (property.is_residential_lease == true) {
        if (parseFloat(property.asking_price) > 1000) {
          return (
            '$' +
            parseFloat(property.asking_price / 1000)
              .toFixed(1)
              .toString() +
            'k'
          );
        } else {
          return '$' + parseFloat(property.asking_price);
        }
      } else {
        if (parseFloat(property.asking_price) > 1000000) {
          return (
            '$' +
            parseFloat(property.asking_price / 1000000)
              .toFixed(1)
              .toString() +
            'm'
          );
        } else {
          return '$' + parseInt(property.asking_price / 1000).toString() + 'k';
        }
      }
    },

    activateIcon({ id, source }) {
      let marker = this.mapMarkers.find(marker => marker.propertyId == id);
      if (marker) {
        marker.setZIndex(9999);
        // marker.setIcon(POINT_MARKER_ICON_CONFIG.active);
        marker.setIcon(this.getMarkerIcon(marker.disabled ? 'disabled' : this.searchType, this.isZoomedIn, true));
        this.lastHighlightedId = id;
      }
    },

    deactivateIcon(id) {
      const index = this.mapMarkers.findIndex(m => m.propertyId == id)
      if(index == -1) return false;
      const marker = this.mapMarkers[index];
      marker.setIcon(this.getMarkerIcon(marker.disabled ? 'disabled' : this.searchType, this.isZoomedIn));
      marker.setZIndex(marker.oldZIndex);
      this.lastHighlightedId = null;
    },

    buildMapMarkers(shouldFitBounds = this.shouldFitBounds){
      // console.trace();
      console.log()
      const { LatLngBounds, LatLng } = this.google.maps;
      const vm = this;  
      this.resetMapMarkers();

      let currentBounds = this.map.getBounds();
      console.log()
      console.log('buildMapMarkers');
      console.log('bounds -> ',currentBounds)
      let bounds = new LatLngBounds();
      if(this.properties && this.properties.length){
        this.properties.map((property, index) => {

          // If there are disabled properties, we want these to sit "on top" of them. This requires us to give these a z index that is at least greater than the number of disabled properties as the index in the array controls its z-index
          let startingZIndex = 0;
          let coords = new LatLng(parseFloat(property.lat), parseFloat(property.lng));
          if(this.disabledProperties && this.disabledProperties.length){
            startingZIndex = this.disabledProperties.length;  
          }
          if(!currentBounds || shouldFitBounds || (!shouldFitBounds && currentBounds.contains(coords))){
            this.createMarker(property, index + startingZIndex, shouldFitBounds ? bounds : false);
          }
          
          
        }); // end  properties loop
      }
      if(this.disabledProperties && this.disabledProperties.length){
        this.disabledProperties.map((property, zIndex) => {
          let coords = new LatLng(parseFloat(property.lat), parseFloat(property.lng));
          if(!currentBounds || shouldFitBounds || (!shouldFitBounds && currentBounds.contains(coords))){
            this.createMarker(property, zIndex, false, true);
          }
        }); // end disabled properties loop
      }

      if(shouldFitBounds){
        this.map.fitBounds(bounds);
      }
      
    },

    createMarker(property, z, bounds, disabled = false){
      const vm = this;
      const { Marker, LatLng } = this.google.maps;
      const { lat, lng } = property;
      let icon = this.getMarkerIcon(disabled ? 'disabled' : this.searchType, vm.isZoomedIn);
      let markerOptions = {
        icon,
        map: this.map,
        position: {
          lat: parseFloat(property.lat),
          lng: parseFloat(property.lng)
        },
        // icon: POINT_MARKER_ICON_CONFIG.wolfnet,
        // zIndex:
        //   property.source == 'rf' || property.source == 'rw'
        //     ? zIndex + vm.maxMarkersCount
        //     : zIndex, // force propertys to appear on top of each other, instead of creating them all on the same "layer".. If RW or RF property , filter it even further to the top
        zIndex: z,
        propertyId: property.id,
        source: property.source
      };

      if (vm.isZoomedIn) {
        markerOptions.label = {
          text: vm.getMarkerLabel(property),
          fontFamily:
            '"Proxima-Nova", "proxima-nova", "Proxima Nova", "Helvetica Neue", Helvetica, Arial',
          fontWeight: '600',
          fontSize: '12px',
          color: '#333'
        };
      }

      let marker = new Marker(markerOptions);

      marker.disabled = disabled;
      marker.oldZIndex = z;
      marker.addListener('mouseover', event => vm.handleMouseEvent({ eventType: 'mouseover', marker, property }));
      marker.addListener('mouseout', event => vm.handleMouseEvent({ eventType: 'mouseout', marker, property }));
      // click
      marker.addListener('click', event => vm.handleMouseEvent({ eventType: 'click', marker, property }));

      vm.mapMarkers.push(marker);

      if(bounds){
        let parsedLat = parseFloat(lat);
        let parsedLng = parseFloat(lng);

        if (parsedLat !== 0 && parsedLng !== 0) {
          bounds.extend(new LatLng(parsedLat, parsedLng));
        }
      }
    },

    updateInvalidCoordsCount(){
      let invalidMarkers = this.mapMarkers.filter(m => (!Math.abs(m.getPosition().lat()) || !Math.abs(m.getPosition().lng())));    
      this.$emit('update-invalid-markers', invalidMarkers.length);
    },

    resetMapMarkers(){
      if (this.mapMarkers.length) {
        this.mapMarkers.forEach(marker => {
          marker.setMap(null);
        });
        this.mapMarkers = [];
      }
    }

    
  },

  render() {},

  watch: {
    properties() {
      const vm = this;

      this.resetMapMarkers();

      this.buildMapMarkers();
      this.updateInvalidCoordsCount();
      
    },

    zoomLevel(zoom, oldZoom){

      if(this.appName == 'portfolio-visualizer-app'){
        this.buildMapMarkers(false);
      }
    },

    highlightedProperty() {
      this.deactivateIcon(this.lastHighlightedId);
      if (this.highlightedProperty.id) {
        this.activateIcon({
          id: this.highlightedProperty.id,
          source: this.highlightedProperty.source
        });
      }

    }
  }
};
</script>
